<template>
  <div class="parents-page" :class="{ 'profile-active': !showListHeader }">
    <Create :createDialog="createDialog" @close="createDialog = false" />
    <div v-if="showListHeader" class="parents-page-header">
      <div>
        <div class="page-eyebrow">Community</div>
        <h1>Parents</h1>
        <p>Manage parent profiles, student relationships, and account balances.</p>
      </div>
      <v-btn v-if="checkRightStatus(7)" color="primary" depressed class="new-parent-button" @click="add">
        <v-icon left>mdi-plus</v-icon>New parent
      </v-btn>
    </div>
    <router-view />
  </div>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import customerStore from "./store.js";
import invoiceStore from "@/modules/Invoice/store.js";
import { mapGetters } from "vuex";
const Create = () => import("./components/Create");

export default {
  name: "customer-index",
  mixins: [RegisterStoreModule],
  components: { Create },
  data() {
    return { createDialog: false };
  },
  computed: {
    ...mapGetters("global", ["checkRightStatus"]),
    showListHeader() { return this.$route.name !== "customer-profile"; },
  },
  created() {
    this.registerStoreModule("customer", customerStore);
    this.registerStoreModule("invoice", invoiceStore);
  },
  methods: {
    add() { this.createDialog = true; },
  },
};
</script>

<style scoped>
.parents-page { min-height: 100%; padding: 30px 36px 48px; background: #f6f8f6; }
.parents-page.profile-active { padding: 0; }
.parents-page-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 22px; }
.page-eyebrow { margin-bottom: 5px; color: #43a047; font-size: 11px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; }
.parents-page-header h1 { margin: 0; color: #172033; font-size: 29px; line-height: 1.2; letter-spacing: -.025em; }
.parents-page-header p { margin: 6px 0 0; color: #728095; font-size: 13px; }
.new-parent-button { height: 42px !important; border-radius: 9px; text-transform: none; letter-spacing: 0; }
@media (max-width: 599px) {
  .parents-page { padding: 22px 14px 36px; }
  .parents-page-header { align-items: flex-start; margin-bottom: 18px; }
  .parents-page-header h1 { font-size: 25px; }
  .parents-page-header p { max-width: 230px; }
  .new-parent-button { min-width: 44px !important; padding: 0 12px !important; }
  .new-parent-button ::v-deep .v-btn__content { font-size: 0; }
  .new-parent-button ::v-deep .v-icon { margin: 0 !important; font-size: 22px !important; }
}
</style>
